import { Markdown as MarkdownComponent } from '@captaincause/ui/Markdown'
import { Button } from 'components/Button'
import { StrapiImage } from './StapiImage'
import type { ReactNode } from 'react'

interface MarkdownImageProps {
  src?: string
  alt?: string
}

function Image({ src = '', alt = '' }: MarkdownImageProps) {
  return (
    <StrapiImage
      caption={alt}
      alternativeText={alt}
      url={src}
      width={1024}
      height={600}
      provider={src.startsWith('http') ? 'external' : 'local'}
      formats
      className="h-auto max-w-[50%] rounded-xl py-8"
    />
  )
}

interface MarkdownLinkProps {
  href?: string
  children?: ReactNode
}

function Link({ href = '', children = null }: MarkdownLinkProps) {
  if (!children) return null

  return (
    <Button variant="tertiary" href={href} inline>
      {children}
    </Button>
  )
}

interface MarkdownProps {
  children: string
  center?: boolean
  isDark?: boolean
  className?: string
}

export function Markdown({
  children,
  center = false,
  isDark = false,
  className = '',
}: MarkdownProps) {
  return (
    <MarkdownComponent
      center={center}
      isDark={isDark}
      components={{ img: Image, a: Link }}
      className={className}
    >
      {children}
    </MarkdownComponent>
  )
}
